import { CompanyRegistryPayload, emptyCompanyRegistryPayload } from "../requests/adminCompanies";

export type CompanyRegistry = CompanyRegistryPayload & {
	id: string;
	deleted: boolean;
};

export const emptyCompanyRegistry: CompanyRegistry = {
	...emptyCompanyRegistryPayload,
	id: "",
	deleted: false,
};
